// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"index-module--rectangle--3Cpvw","logo":"index-module--logo--2R0qx"};